var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{photo_tip_color:1,banner:1,wait:!_vm.is_finished,ing:_vm.is_finished,global_wait:!_vm.is_finished&&_vm.isGlobal,completed:_vm.page_type==='success'}},[_c('p')]),_vm._v(" "),_c('div',{staticClass:"split"})])}
var staticRenderFns = []

export { render, staticRenderFns }